export default "__VITE_ASSET__DoY68oVc__ 1000w";